import React, { FC } from 'react';
import { useActiveWsIdState } from 'src/models/workspace/hooks';
import { useTranslation } from 'react-i18next';
import NotificationsDropdown from 'src/shared/Notifications/NotificationsDropdown';
import { NotificationGroupName } from 'src/models/notifications/types';
import { NotificationType } from '@tendium/prom-types/notifications';

export const WorkspaceNotifications: FC = () => {
  const [id] = useActiveWsIdState();
  const { t } = useTranslation();
  return (
    <NotificationsDropdown
      key={id}
      id={id}
      type={NotificationType.tenderUpdate}
      groupName={NotificationGroupName.WS_SENDOUT}
      label={t('Notifications.allUpdates')}
      desc={t('Notifications.workspaceNotificationsDesc')}
      eventSource={'Workspace'}
    />
  );
};

export default WorkspaceNotifications;
